export default __webpack_public_path__ + "static/media/incidentReporting.png.webp";